import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const ActiveSlideStyle = {
  zIndex: 5,
  opacity: 1,
  transform: 'translateY(0%)',
};

/** 
 * PortraitBox:
 * - Smoother fade/slide in 
 * - Maintained aspect ratio constraints 
 */
export const PortraitBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isLoaded',
  name: 'PortraitBox',
})(({ theme, isLoaded }) => ({
  width: '100%',
  height: '100vh',
  margin: 0,
  position: 'relative',
  overflow: 'hidden',
  maxHeight: '100vh',
  opacity: isLoaded ? 1 : 0,
  transition: 'opacity 1s ease, transform 1s ease',

  '@media (max-aspect-ratio: 3/4)': {
    width: '100%',
    height: '100vh',
    maxWidth: '100%',
    overflowY: 'auto',
  },
  '@media (min-aspect-ratio: 3/4)': {
    width: 'auto',
    aspectRatio: '9/16',
    height: '95vh',
    maxWidth: '95vh',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: isLoaded ? 'translate(-50%, -50%)' : 'translate(-50%, 50%)',
    borderRadius: '12px',
    boxShadow: '0 0 30px rgba(0, 0, 0, 0.3)',
  },
}));

export const BackgroundPattern = styled(Box)(({ theme }) => ({
  position: 'absolute',
  inset: 0,
  overflow: 'hidden',
  zIndex: 0,
  background: `
    repeating-linear-gradient(
      45deg,
      rgba(123, 42, 42, 0.25),
      rgba(123, 42, 42, 0.25) 8px,
      rgba(100, 30, 30, 0.25) 8px,
      rgba(100, 30, 30, 0.25) 16px
    )
  `,
}));

export const Background = styled(Box)(({ theme }) => ({
  position: 'absolute',
  inset: 0,
  zIndex: 1,
  background: `linear-gradient(180deg, rgba(123, 42, 42, 0.7), #191414 95%)`,
}));

export const Slide = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'currentIndex' && prop !== 'index',
  name: 'Slide',
})(({ theme, index, currentIndex }) => ({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2rem',
  textAlign: 'center',
  opacity: 0,
  transform: 'translateY(15%)',
  transition: 'opacity 0.6s ease, transform 0.6s ease',
  ...(currentIndex === index && ActiveSlideStyle),
}));

/**
 * NavDots & Dot:
 * - Slightly bigger by default, subtle animation on hover.
 */
export const NavDots = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: '2rem',
  left: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'center',
  gap: '8px',
  zIndex: 10,
}));

export const Dot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active',
  name: 'Dot',
})(({ theme, active }) => ({
  width: '12px',
  height: '12px',
  borderRadius: '50%',
  backgroundColor: active ? theme.palette.secondary.main : theme.palette.secondary.light,
  cursor: 'pointer',
  transition: 'background-color 0.3s ease, transform 0.3s ease',
  transform: active ? 'scale(1.3)' : 'scale(1)',
  '&:hover': {
    transform: 'scale(1.4)',
  },
}));
